@if (!isHidden) {
    <div class="flex flex-col gap-4 justify-items-center h-full" [ngClass]="{ 'ca-checkbox-tile-slot-with-visual': isVisual }">
        <div class="relative h-full">
            <mat-checkbox class="ca-checkbox-tile-slot" [(ngModel)]="checked" (blur)="onTouched()">
                @if (isVisual) {
                    <div class="ca-checkbox-visual-container">
                        <ca-visual [slot]="slot()"></ca-visual>
                    </div>
                }
                <div class="ca-checkbox-label-text flex items-center gap-2 pr-2">
                    @let title = slot().titleKey | translationKey: slot().titleData;
                    @if (title) {
                        <span class="flex-grow">{{ title }}</span>
                    }
                    @if (slot() | slotTooltip; as tooltip) {
                        <ca-visual [tooltip]="tooltip"></ca-visual>
                    }
                </div>
                @if (checked) {
                    <div class="flex items-start ca-optional-input">
                        <mat-form-field
                            floatLabel="always"
                            subscriptSizing="dynamic"
                            appearance="outline"
                            [hideRequiredMarker]="true"
                            class="ca-form-field ca-form-field-xs with-label ca-form-field-w-full with-error-message"
                        >
                            <mat-label>{{ slot().labelKey | translationKey: slot().labelData }}</mat-label>
                            <input
                                matInput
                                (input)="onValueChange(control.value)"
                                [disabled]="!!isDisabled"
                                [formControl]="control"
                                [placeholder]="(slot().placeholderKey | translationKey: slot().placeholderData) ?? ''"
                                [mask]="mask.pattern"
                                [patterns]="mask.customPatterns!"
                                [decimalMarker]="mask.decimalMarker!"
                                [separatorLimit]="mask.separatorLimit!"
                                [dropSpecialCharacters]="mask.dropSpecialCharacters!"
                                [suffix]="(slot().suffixKey | translationKey: slot().suffixData) ?? ''"
                                [prefix]="(slot().prefixKey | translationKey: slot().prefixData) ?? ''"
                            />
                            @if (isErrorMessage) {
                                <mat-error>
                                    <ca-form-error-message>
                                        {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                                    </ca-form-error-message>
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
            </mat-checkbox>
        </div>
    </div>
}
